<template>
	<p class="mb-3" v-html="item.description"></p>
	<template v-for="(fieldGroup,fieldTypeIndex) in item.fields">
		<input-unit
				v-if="fieldGroup.type === 'input'"
				v-model="form[fieldGroup.question]"
				:options="{
							slug: `field_${fieldTypeIndex}`,
							name: fieldGroup.question,
							readonly: loading,
							required: true,
						}"
		/>

		<template v-if="fieldGroup.type === 'check'">
			<label>
				{{ fieldGroup.question }}
			</label>
			<template v-for="(answer,index) in fieldGroup.answers">
				<div class="checkbox-unit">
					<input
							type="checkbox"
							class="checkbox-unit__input"
							:id="answer.answer"
							:name="answer.answer"
							v-model="form[fieldGroup.question]"
							:value="answer.answer"
							:disabled="loading"
							required
					>
					<label class="checkbox-unit__label" :for="answer.answer">
						{{ answer.answer }}
					</label>
				</div>
			</template>
		</template>

		<vue-select-unit
				v-if="fieldGroup.type === 'select'"
				v-model="form[fieldGroup.question]"
				:options="{
							slug: `field_${fieldTypeIndex}`,
							name: fieldGroup.question,
							label: 'answer',
							options: fieldGroup.answers.filter(element => element.answer),
							reduceFn: (option) => option.answer,
							disabled: loading,
							required: true
						}"
		/>

		<div class="mt-3">
			<radio-button-unit
					v-if="fieldGroup.type === 'radio'"
					v-model="form[fieldGroup.question]"
					:options="{
								slug: `field_${fieldTypeIndex}`,
								name: fieldGroup.question,
								options: fieldGroup.answers.map((answer,index) => { return {name: answer.answer, value: answer.answer, readonly: loading}}),
								required: true,
							}"
			/>
		</div>
	</template>

	<honeypot-field v-model="honeypot"/>
	<privacy-notice/>

	<div class="d-flex justify-content-center">
		<button-unit
				@click-on-btn="sendForm"
				:options="{
							text: 'Elküld',
							textColor: 'var(--color-header-text)',
							bgColor: 'var(--color-header-button-bg)',
							shape: ButtonUnitShape.RECTANGLE,
							disabled: loading
						}"
		/>
	</div>
</template>
<script lang="ts">
import {defineComponent, PropType} from 'vue'
import InputUnit from "../Units/InputUnit.vue";
import RadioButtonUnit from "../Units/RadioButtonUnit.vue";
import VueSelectUnit from "../Units/VueSelectUnit.vue";
import ButtonUnit from "../Units/ButtonUnit.vue";
import HoneypotField from "../Units/HoneypotField.vue";
import PrivacyNotice from "../Units/PrivacyNotice.vue";
import {formErrorMessage, protectionPayload} from "@/WebApp/Utils/FormProtection";
import {ButtonUnitShape} from "../Units/Interfaces/ButtonUnitShape";
import {FormInputInterface} from "../../Views/PageView/Interfaces/Components/FormInputInterface";
import {fireAlert} from "@/WebApp/Utils/Alert";
import axios from "axios";
import {FormComponentInterface} from "../../Views/PageView/Interfaces/Components/FormComponentInterface";

export default defineComponent({
	name: "InlineForm",
	components: {PrivacyNotice, HoneypotField, ButtonUnit, VueSelectUnit, RadioButtonUnit, InputUnit},
	props: {
		item: {
			type: Object as PropType<FormComponentInterface>,
			required: true,
		}
	},
	data() {
		return {
			loading: false,
			honeypot: '',
			form: {} as PropType<FormInputInterface>,
		}
	},
	computed: {
		ButtonUnitShape() {
			return ButtonUnitShape;
		}
	},
	mounted() {
		this.resetFormFields();
	},
	methods: {
		resetFormFields(): void {
			this.item.fields.forEach((field: any) => {
				let question = field.question;
				//@ts-ignore
				this.form[question] = field.type === 'check' ? [] : '';
			});
		},
		checkFormLength(): boolean {
			let missingData = false;
			this.item.fields.forEach((field: any) => {
				let question = field.question;
				//@ts-ignore
				if (this.form[question].length === 0) {
					missingData = true;
				}
			});

			return missingData;
		},
		async sendForm(): Promise<void> {

			if (this.checkFormLength()) {
				fireAlert('Hiányzó űrlap mezők!', 'Hiányzó űrlap mezők!', 'error');
				return;
			}

			this.loading = true;
			const protection = await protectionPayload(this.honeypot, 'form');
			axios.post('/api/forms', {answers: {...this.form}, group: this.item.formId, url: window.location.href, ...protection}).then((response: any) => {
				if (response.status === 200 && response.data.success === true) {
					this.resetFormFields();
					fireAlert('Sikeres kitöltve!', this.item?.success_message ?? 'Sikeres űrlap kitöltés!', 'success');
				}
			}).catch((error: any) => {
				fireAlert('Hiba történt!', formErrorMessage(error, 'Valami hiba történt!'), 'error');
			}).finally(() => {
				this.loading = false;
			})
		}
	}
})
</script>
<style scoped>

</style>
